import { action, observable } from "mobx";
import { ConfirmDialogOptions } from "./ConfirmDialogOptions";

type Callback<T> = (value: T) => void;
export type OptionsBuilder<T> = (options: ConfirmDialogOptions<T>) => void;

export class ConfirmDialogStore {
  private _onAction: Callback<any>;
  @observable private _open = false;
  @observable private _options: ConfirmDialogOptions<any>;

  get options() {
    return this._options;
  }

  get open() {
    return this._open;
  }

  @action.bound confirm<T>(arg: ConfirmDialogOptions<T> | OptionsBuilder<T>) {
    const options = typeof arg !== "function" ? arg : new ConfirmDialogOptions<T>();

    if (typeof arg === "function") {
      arg(options);
    }

    return new Promise<T>((resolve) => {
      this.openDialog(options, resolve);
    });
  }

  @action.bound openDialog<T>(opts: ConfirmDialogOptions<T>, onAction: Callback<T>) {
    this._onAction = onAction;
    this._options = opts;
    this._open = true;
  }

  @action.bound onClick(value: string) {
    this._onAction && this._onAction(value);
    this._open = false;
  }
}
